import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@features/auth/hooks/useAuthStore';
import type { UserRole } from '@/features/auth/services/session.service';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export function RoleGuard({ children, allowedRoles }: RoleGuardProps) {
  const role = useAuthStore((s) => s.role);

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
